/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { CheckboxGroup, Checkbox, Stack, FormControl, FormErrorMessage } from '@chakra-ui/react'

const AIStrategies = ({
  errorMessage,
  control,
  controller: Controller,
  licensedAsset
}) => {
  const fileType = licensedAsset.asset.fileType
  const currentRadios = licensedAsset.aiStrategies.map((aiStrategy) => {
    return (
      <Stack key={`ai-strategies-${aiStrategy.id}`} gap="0px">
        <Checkbox
          size="lg"
          value={`${aiStrategy.id}`}
        >
          { aiStrategy.name }
        </Checkbox>
        <div className="text-sm">
          Estimate cost: ${aiStrategy.costPer1000Chars}
        </div>
      </Stack>
    )
  })

  return (
    <section>
      <FormControl isInvalid={errorMessage}>
        <h3>Pre-Deal AI Strategies ({fileType})</h3>
        <Controller
          name="preDealAIStrategies"
          control={control}
          render={({ field }) => (
            <CheckboxGroup {...field }>
              <Stack gap="10px">
                { currentRadios }
              </Stack>
            </CheckboxGroup>
          )}
        />
        {errorMessage && (
          <FormErrorMessage>{errorMessage}</FormErrorMessage>
        )}
      </FormControl>
    </section>
  )
}

export default AIStrategies
